import { useCallback, useRef, useState } from 'react';
import { TextInput } from '../../Atoms';

const SubmitTextInput = ({ value, ...other }) => {
  const [originalValue] = useState(value);
  const ref = useRef();

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter') {
        e.target.blur();
      }
      if (e.key === 'Escape') {
        e.nativeEvent.stopImmediatePropagation();
        e.preventDefault();
        e.target.value = originalValue;
        e.target.blur();
      }
    },
    [originalValue]
  );

  return <TextInput value={value} {...other} onKeyDown={onKeyDown} ref={ref} />;
};

SubmitTextInput.propTypes = {
  ...TextInput.propTypes,
};

SubmitTextInput.defaultProps = {
  ...TextInput.defaultProps,
  mode: 'subtle',
};

export default SubmitTextInput;
